import React, { useState } from 'react';
import Footer from '../components/Footer';
import { Button, Form, Image } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { persistor } from '../store';
import { confirmResetPassword, ConfirmResetPasswordInput, signOut } from 'aws-amplify/auth';
import { resetPassword, type ResetPasswordOutput } from 'aws-amplify/auth';

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [confirmationCode, setConfirmationCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const backendURL = 'http://localhost:3001';

    const handleResetPassword = async () => {
        try {
            const output = await resetPassword({ username: email })
            handleResetPasswordNextSteps(output);
        } catch (error) {
            console.error(error);
        }
    }

    const handleResetPasswordNextSteps = async (output: ResetPasswordOutput) => {
        const { nextStep } = output;
        console.log(nextStep);

        switch (nextStep.resetPasswordStep) {
            case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
                const codeDeliveryDetails = nextStep.codeDeliveryDetails;
                console.log(
                    `Confirmation code was sent to ${codeDeliveryDetails.deliveryMedium}`
                );
                setIsSuccess(true);
                break;
            case 'DONE':
                console.log('Successfully reset password.');
                break;
        }

        alert('パスワードリセットコードを送信しました。');

    }

    const handleConfirmResetPassword = async () => {
        if (newPassword.length > 0 == false || newPassword2.length > 0 == false) {
            alert('パスワードを入力してください。');
            setErrorMessage('パスワードを入力してください。');
            return;
        }

        if (newPassword !== newPassword2) {
            alert('パスワードが一致していません。');
            setErrorMessage('パスワードの確認が一致していない');
            return;
        }

        try {
            await confirmResetPassword({ username: email, confirmationCode, newPassword })
            persistor.purge();
            await signOut({ global: true });
            alert('パスワードリセットに成功しました。');
            navigate('/');
        } catch (error: any) {
            if (error.name === 'CodeMismatchException') {
                alert('認証コードが間違っています。');
            } else if (error.name === 'ExpiredCodeException') {
                alert('認証コードの有効期限が切れています。もう一度リセット手続きを行ってください。');
            } else if (error.name === 'InvalidParameterException') {
                alert('パスワーのドは8文字以上で、英字と数字を含めてください。');
            } else {
                alert('エラーが発生しました。もう一度やり直してください。');
            }
            console.error(error);
        }
    }

    return (
        <>
            {isSuccess ? (
                <>
                    <section className="registration-nav"></section>
                    <section className="section-login registration-min-section login-bg-img">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-8 col-sm-10 mx-auto">
                                    <div className="login-wrapper bg-white rounded-50 theme-box-shadow-2 p-lg-5 p-4 text-center">
                                        <div className="p-lg-4">
                                            <Image className="img img-fluid login-logo mb-4" src="assets/images/login/reset-icon.svg" />
                                            <h3 className="text-md mb-lg-5 mb-4">パスワードをリセットする</h3>
                                            <Form className="form-theme" method="POST">
                                                <Form.Group className="form-group mb-sm-4 mb-3">
                                                    <Form.Label htmlFor="password">
                                                        確認コード
                                                        <Image className="img img-fluid required-icon" src="assets/images/registration/required-icon.svg" />
                                                    </Form.Label>
                                                    <Form.Control className="form-control" placeholder="確認コード"
                                                        name="confirmationCode" value={confirmationCode}
                                                        onChange={(e) => setConfirmationCode(e.target.value)} />
                                                </Form.Group>
                                                <Form.Group className="form-group mb-sm-4 mb-3">
                                                    <Form.Label htmlFor="password">
                                                        新しいパスワード
                                                        <Image className="img img-fluid required-icon" src="assets/images/registration/required-icon.svg" />
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password" className="form-control"
                                                        name="password" id="password"
                                                        placeholder="新しいパスワードを入力" required minLength={8}
                                                        value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                    />
                                                </Form.Group>
                                                <Form.Group className="form-group mb-sm-4 mb-3">
                                                    <Form.Label htmlFor="password">
                                                        新しいパスワード（確認）
                                                        <Image className="img img-fluid required-icon" src="assets/images/registration/required-icon.svg" />
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="password" className="form-control"
                                                        name="password2" id="password2"
                                                        placeholder="新しいパスワード（確認）を入力" required minLength={8}
                                                        value={newPassword2}
                                                        onChange={(e) => setNewPassword2(e.target.value)}
                                                    />
                                                </Form.Group>
                                                <Button onClick={handleConfirmResetPassword} className="btn btn-theme btn-danger rounded-pill px-lg-5 mb-5"><span
                                                    className="px-lg-5 px-4">送信</span></Button>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            ) : (
                <>
                    <section className="registration-nav"></section>
                    <section className="section-login registration-min-section login-bg-img">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-8 col-sm-10 mx-auto">
                                    <div className="login-wrapper bg-white rounded-50 theme-box-shadow-2 p-lg-5 p-4 text-center">
                                        <div className="p-lg-5">
                                            <Image className="img img-fluid login-logo mb-4" src="assets/images/login/reset-icon.svg" />
                                            <h3 className="text-md mb-lg-5 mb-4">パスワードをリセットする</h3>
                                            <Form className="form-theme" method="POST">
                                                <Form.Group className="form-group mb-sm-4 mb-3">
                                                    <Form.Control className="form-control" placeholder="ユーザーネーム"
                                                        name="username" value={email}
                                                        onChange={(e) => setEmail(e.target.value)} />
                                                </Form.Group>
                                                <Button onClick={handleResetPassword} className="btn btn-theme btn-danger rounded-pill px-lg-5 mb-5"><span
                                                    className="px-lg-5 px-4">送信</span></Button>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}

            <Footer />
        </>
    )
}

export default ForgotPassword;